import React from 'react'
import {
    FormControl,
    Text,
    Stack, Box,
    FormErrorMessage, FormHelperText,
    CheckboxGroup as ChakraCheckboxGroup, Checkbox,
  } from "@chakra-ui/react"
  
export const CheckboxGroup = ({error, label, info, onChange, value= [], options=[],  showerror=true, required, children, ...props}) => {
        
    
    return(
        <FormControl isInvalid={error}>
            {label && <Text my="0" mb="5" fontSize="12px" color="gray.400" fontWeight="600" textTransform="uppercase">{label} {required && <Text as={'span'} m="0" fontSize="xs" color="red">*</Text>}</Text>}
            {
                showerror && <FormErrorMessage>{error}</FormErrorMessage>
            }
            {
                info && <FormHelperText>{info}</FormHelperText>
            }
            <ChakraCheckboxGroup 
                 value={value}
                 onChange={(val) => onChange(val)}
                 {...props}
                >
                <Stack spacing={0} mt={4} mx="-10px"  direction="row" flexWrap="wrap">
                    {
                        options?.map((opt, o) =>
                            <Box w="50%" px="10px" py="5px" key={o}>
                                <Checkbox _focusVisible={false} _focus={{ boxShadow: 'none' }} key={o} value={opt?.value+""} isChecked={() => value?.includes(opt?.value)}>
                                    <Text m="0" fontSize={props?.size === "lg" ? "16px" : "14px"}>{opt?.label}</Text>
                                </Checkbox>
                            </Box>
                        )
                    }                    
                </Stack>
            </ChakraCheckboxGroup>
        </FormControl>
    )
}